import { isFeatureEnabled } from 'owa-feature-flags';

export default function isPinnableExperienceEnabled(): boolean {
    return isFeatureEnabled('addin-inClientStorePinnableExperience');
}
